import $ from 'jquery';

/**
 * Handle scrolling to anchor elements
 *
 * @type {DynamicInitFunction<HTMLAnchorElement>}
 */
export default ($collection) => {

	$collection.on('click.scroll-to-hash', (e) => {

		/** @type {JQuery<HTMLAnchorElement>} */
		const $link = $(e.currentTarget);
		const href = $link.attr('href').replace('#', '');

		// Skip empty hash
		if (!href || Number.isInteger(href)) {
			return void 0;
		}

		const selector = $.escapeSelector(href);
		let $target = $(`#${selector}`);
		if ($target.length === 0) {
			$target = $(`a[name="${selector}"]`);
		}

		if ($target.length > 0) {
			// No need to 'blink' from js, there is a css rule that takes care of the blinking animation (_scroll_target.scss)
			mpro.scrollToElement($target, { speed: 266, focusMiddle: false, blink: false, offsetY: $link.data('offset-y') || 0 });
			window.location.hash = href;
			return false;
		}

		return void 0;
	});
};